// @module StellarGrade.ST_Common.GlobalViews
define('StellarGrade.ST_Common.LoginRegister_Register.View', [
    'stellargrade_st_common_loginregister_register.tpl',
    'LoginRegister.Register.View',
    'Utils',
    'jQuery',
    'underscore',
    'Configuration',
], function (stellargrade_st_common_loginregister_register_tpl, LoginRegisterRegisterView, Utils, $, _, Configuration) {
    'use strict';

    const COUNTRIES_WITH_STATES = [
        {
            country: 'Canada',
            id: 'CA',
            states: [
                { id: 101, code: 'AB', name: 'Alberta' },
                { id: 102, code: 'BC', name: 'British Columbia' },
                { id: 103, code: 'MB', name: 'Manitoba' },
                { id: 104, code: 'NB', name: 'New Brunswick' },
                { id: 105, code: 'NL', name: 'Newfoundland and Labrador' },
                { id: 106, code: 'NS', name: 'Nova Scotia' },
                { id: 107, code: 'ON', name: 'Ontario' },
                { id: 108, code: 'PE', name: 'Prince Edward Island' },
                { id: 109, code: 'QC', name: 'Quebec' },
                { id: 110, code: 'SK', name: 'Saskatchewan' },
                { id: 111, code: 'NU', name: 'Nunavut' },
                { id: 112, code: 'YT', name: 'Yukon' },
            ],
        },
        {
            country: 'Mexico',
            id: 'MX',
            states: [
                { id: 500, code: 'AGS', name: 'Aguascalientes' },
                { id: 501, code: 'BC', name: 'Baja California' },
                { id: 502, code: 'BCS', name: 'Baja California Sur' },
                { id: 503, code: 'CAM', name: 'Campeche' },
                { id: 504, code: 'CHIS', name: 'Chiapas' },
                { id: 505, code: 'CHIH', name: 'Chihuahua' },
                { id: 506, code: 'COAH', name: 'Coahuila' },
                { id: 507, code: 'COL', name: 'Colima' },
                { id: 508, code: 'DGO', name: 'Durango' },
                { id: 509, code: 'GTO', name: 'Guanajuato' },
                { id: 510, code: 'GRO', name: 'Guerrero' },
                { id: 511, code: 'HGO', name: 'Hidalgo' },
                { id: 512, code: 'JAL', name: 'Jalisco' },
                { id: 513, code: 'CDMX', name: 'Mexico City' },
                { id: 514, code: 'MICH', name: 'Michoacán' },
                { id: 515, code: 'MOR', name: 'Morelos' },
                { id: 516, code: 'MEX', name: 'México (Estado de)' },
                { id: 517, code: 'NAY', name: 'Nayarit' },
                { id: 518, code: 'NL', name: 'Nuevo León' },
                { id: 519, code: 'OAX', name: 'Oaxaca' },
                { id: 520, code: 'PUE', name: 'Puebla' },
                { id: 521, code: 'QRO', name: 'Querétaro' },
                { id: 522, code: 'QROO', name: 'Quintana Roo' },
                { id: 523, code: 'SLP', name: 'San Luis Potosí' },
                { id: 524, code: 'SIN', name: 'Sinaloa' },
                { id: 525, code: 'SON', name: 'Sonora' },
                { id: 526, code: 'TAB', name: 'Tabasco' },
                { id: 527, code: 'TAMPS', name: 'Tamaulipas' },
                { id: 528, code: 'TLAX', name: 'Tlaxcala' },
                { id: 529, code: 'VER', name: 'Veracruz' },
                { id: 530, code: 'YUC', name: 'Yucatán' },
                { id: 531, code: 'ZAC', name: 'Zacatecas' },
            ],
        },
        {
            country: 'United States',
            id: 'US',
            states: [
                { id: 0, code: 'AL', name: 'Alabama' },
                { id: 1, code: 'AK', name: 'Alaska' },
                { id: 2, code: 'AS', name: 'American Samoa' },
                { id: 3, code: 'AZ', name: 'Arizona' },
                { id: 4, code: 'AR', name: 'Arkansas' },
                { id: 5, code: 'CA', name: 'California' },
                { id: 6, code: 'CO', name: 'Colorado' },
                { id: 7, code: 'CT', name: 'Connecticut' },
                { id: 8, code: 'DE', name: 'Delaware' },
                { id: 9, code: 'DC', name: 'District of Columbia' },
                { id: 10, code: 'FL', name: 'Florida' },
                { id: 11, code: 'GA', name: 'Georgia' },
                { id: 12, code: 'GU', name: 'Guam' },
                { id: 13, code: 'HI', name: 'Hawaii' },
                { id: 14, code: 'ID', name: 'Idaho' },
                { id: 15, code: 'IL', name: 'Illinois' },
                { id: 16, code: 'IN', name: 'Indiana' },
                { id: 17, code: 'IA', name: 'Iowa' },
                { id: 18, code: 'KS', name: 'Kansas' },
                { id: 19, code: 'KY', name: 'Kentucky' },
                { id: 20, code: 'LA', name: 'Louisiana' },
                { id: 21, code: 'ME', name: 'Maine' },
                { id: 22, code: 'MD', name: 'Maryland' },
                { id: 23, code: 'MA', name: 'Massachusetts' },
                { id: 24, code: 'MI', name: 'Michigan' },
                { id: 25, code: 'MN', name: 'Minnesota' },
                { id: 26, code: 'MS', name: 'Mississippi' },
                { id: 27, code: 'MO', name: 'Missouri' },
                { id: 28, code: 'MT', name: 'Montana' },
                { id: 29, code: 'NE', name: 'Nebraska' },
                { id: 30, code: 'NV', name: 'Nevada' },
                { id: 31, code: 'NH', name: 'New Hampshire' },
                { id: 32, code: 'NJ', name: 'New Jersey' },
                { id: 33, code: 'NM', name: 'New Mexico' },
                { id: 34, code: 'NY', name: 'New York' },
                { id: 35, code: 'NC', name: 'North Carolina' },
                { id: 36, code: 'ND', name: 'North Dakota' },
                { id: 37, code: 'MP', name: 'Northern Mariana Islands' },
                { id: 38, code: 'OH', name: 'Ohio' },
                { id: 39, code: 'OK', name: 'Oklahoma' },
                { id: 40, code: 'OR', name: 'Oregon' },
                { id: 41, code: 'PA', name: 'Pennsylvania' },
                { id: 42, code: 'PR', name: 'Puerto Rico' },
                { id: 43, code: 'RI', name: 'Rhode Island' },
                { id: 44, code: 'SC', name: 'South Carolina' },
                { id: 45, code: 'SD', name: 'South Dakota' },
                { id: 46, code: 'TN', name: 'Tennessee' },
                { id: 47, code: 'TX', name: 'Texas' },
                { id: 48, code: 'UT', name: 'Utah' },
                { id: 49, code: 'VT', name: 'Vermont' },
                { id: 50, code: 'VI', name: 'Virgin Islands' },
                { id: 51, code: 'VA', name: 'Virginia' },
                { id: 52, code: 'WA', name: 'Washington' },
                { id: 53, code: 'WV', name: 'West Virginia' },
                { id: 54, code: 'WI', name: 'Wisconsin' },
                { id: 55, code: 'WY', name: 'Wyoming' },
            ],
        },
    ];

    const CURRENCIES = [
        { id: 1, code: 'CAN', name: 'Canadian Dollar' },
        { id: 3, code: 'USD', name: 'US Dollar' },
    ];

    var currentDomain = window.location.origin;
    const SANDBOX = currentDomain === 'https://stagingsb1.stealth.com' ? true : false;
    const IS_SANDBOX2 = currentDomain === 'https://stagingsb2.stealth.com' ? true : false;

    const URL_SEGMENTATION_SB =
        'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2117&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQtXCMdmQts5BrRdO_knS8_7IZTUSK06MvwORzlWif930';
    const URL_CREATE_WEB_USER_SB =
        'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2115&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQnV4Fk5PLxdPfB6Rv0HK8jtbsGHoCHvzIN3XYaqPBRdY';
    if (IS_SANDBOX2) {
        URL_CREATE_WEB_USER_SB =
            'https://439653-sb2.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2115&deploy=1&compid=439653_SB2&ns-at=AAEJ7tMQESUOKhFdPeNNSHPCQwb9SSB5CGfaPJz7ifq1nPDN3ZY';
    }
    const URL_SEGMENTATION_PROD =
        'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2117&deploy=1&compid=439653&ns-at=AAEJ7tMQUogA8ioir11maFsIzNZL0s9BKVjBP1WgNUHvCshdSnc';
    const URL_CREATE_WEB_USER_PROD =
        'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=2115&deploy=1&compid=439653&ns-at=AAEJ7tMQH_YBLrdeKvWNKEG8AlyU5Rboc4utw9MMWLzsbYL8LJI';

    return {
        loadModule: function () {
            _.extend(LoginRegisterRegisterView.prototype, {
                template: stellargrade_st_common_loginregister_register_tpl,

                events: {
                    'click #register-button': 'handleFormSubmit',
                    'change #register-country': 'updateStatesDropdown',
                    'change #register-password': 'updateValidationFields',
                    'change #register-password2': 'updateValidationFields',
                },

                updateValidationFields: function () {
                    var password1Field = this.$('#register-password');
                    var password2Field = this.$('#register-password2');
                    var password1 = password1Field.val();
                    var password2 = password2Field.val();
                    if (password1 && password2) {
                        if (password1 === password2) {
                            password1Field.removeClass('error-placeholder');
                            password1Field.css('border', '');
                            password2Field.removeClass('error-placeholder');
                            password2Field.css('border', '');
                        }
                    }
                },

                handleFormSubmit: function (e) {
                    e.preventDefault();
                    if (this.isSubmitting) return;
                    var self = this;
                    this.isSubmitting = true;
                    var submitButton = this.$('#register-button')[0];
                    var password1Field = this.$('#register-password');
                    var password2Field = this.$('#register-password2');
                    var isResetPassword;

                    submitButton.disabled = true;
                    submitButton.textContent = 'Submitting...';
                    submitButton.style.backgroundColor = '#6c757d';
                    submitButton.style.border = '1px solid #6c757d';
                    var formData = {
                        companyName: this.$('#register-company').val(),

                        custentity_cust_segmentation_pri: this.$('#register-industry').val(),
                        currency: this.$('#register-currency').val(),
                        address1: this.$('#register-address1').val(),
                        address2: this.$('#register-address2').val(),

                        country: this.$('#register-country').val(),
                        state: this.$('#register-state').val(),
                        city: this.$('#register-city').val(),
                        zip: this.$('#register-zip').val(),

                        firstName: this.$('#register-firstname').val(),
                        lastName: this.$('#register-lastname').val(),
                        email: this.$('#register-email').val(),
                        phone: this.$('#register-phone').val(),
                        phoneExt: this.$('#register-phoneext').val(),

                        password: this.$('#register-password').val(),
                        password2: this.$('#register-password2').val(),

                        entityStatus: 35, // LEAD-Unqualified SandBox // 35 LEAD-Website Reg. SandBox
                        leadsource: 44277, // Website
                        salesrep: 43, // House Acct
                    };

                    var urlWebUser = SANDBOX ? URL_CREATE_WEB_USER_SB : URL_CREATE_WEB_USER_PROD;

                    // console.log('formData', formData);

                    // Field Validation
                    var validationError = this.validateFormData(formData);
                    if (validationError) {
                        var errorfield = this.$(validationError.field);

                        if (validationError.field === '#register-industry' || validationError.field === '#register-currency' || validationError.field === '#register-country') {
                            var errorfield = this.$(validationError.field);
                            var selectedOption = errorfield.find('option:selected');
                            selectedOption.text('-- ' + validationError.message + ' --');
                            errorfield.css('color', 'red');
                            errorfield.on('click', function () {
                                $(this).css('border', '1px solid black');
                                errorfield.css('color', '#231F20');
                                selectedOption.text('-- Select Option --');
                            });
                        } else {
                            errorfield.attr('placeholder', validationError.message);
                            errorfield.addClass('error-placeholder');
                        }
                        errorfield.css('border', '4px solid red');
                        errorfield.on('input', function () {
                            $(this).css('border', '1px solid black');
                            $(this).attr('placeholder', '');
                            $(this).removeClass('error-placeholder');
                        });

                        self.isSubmitting = false;
                        submitButton.textContent = 'Create Account';
                        submitButton.disabled = false;
                        submitButton.hidden = false;
                        submitButton.style.backgroundColor = ' #E31B23';

                        if (validationError.message === 'Both password fields are required.') {
                            password2Field.attr('placeholder', validationError.message);
                            password2Field.addClass('error-placeholder');
                            password2Field.css('border', '4px solid red');
                        }
                        return;
                    }

                    function showPopup(message) {
                        const popup = document.getElementById('login-register-register-popup');
                        const msg = document.getElementById('login-register-register-popup-message');
                        msg.textContent = message;
                        popup.classList.remove('hidden');
                    }
                    function showResetPopup(message, isResetPassword) {
                        const popup = document.getElementById('login-register-reset-password-popup');
                        const msg = document.getElementById('login-register-reset-password-popup-message');
                        msg.textContent = message;
                        popup.classList.remove('hidden');
                        // console.log('Popup opened');
                    }

                    function closePopup(isResetPassword) {
                        // console.log('Popup closed', { isResetPassword: isResetPassword });
                        // if (!SANDBOX) {
                        if (isResetPassword === 1) {
                            document.getElementById('login-register-reset-password-popup').classList.add('hidden');
                            window.location.href = '/scs/checkout.ssp?is=register&login=T&reset=T&newcust=T&fragment=login-register#/forgot-password';
                        } else if (isResetPassword === 0) {
                            document.getElementById('login-register-reset-password-popup').classList.add('hidden');
                            window.location.href = '/scs/checkout.ssp?is=checkout&fragment=register#/login-register';
                        } else {
                            document.getElementById('login-register-register-popup').classList.add('hidden');
                            window.location.href = '/scs/checkout.ssp?is=checkout&fragment=register#/login-register';
                        }
                        // }
                    }

                    document.getElementById('login-register-register-popup-close').addEventListener('click', function () {
                        closePopup((isResetPassword = 2));
                    });
                    document.getElementById('login-register-reset-password-popup-yes').addEventListener('click', function () {
                        closePopup((isResetPassword = 1));
                    });
                    document.getElementById('login-register-reset-password-popup-no').addEventListener('click', function () {
                        closePopup((isResetPassword = 0));
                    });

                    $.ajax({
                        url: urlWebUser,
                        type: 'POST',
                        data: JSON.stringify(formData),
                        contentType: 'application/json',
                        success: function (response) {
                            self.isSubmitting = false;
                            submitButton.disabled = false;
                            console.log('response', response);
                            if (response.error) {
                                if (response.error.name === 'UNIQUE_CUST_ID_REQD') {
                                    alert('Email already exists. Please try again with a different email address.');
                                    return;
                                } else if (response.error === 'UNIQUE_EMAIL_NAME_REQD') {
                                    alert('Email already exist link with another name!');
                                    return;
                                } else if (response.error === 'CONTACT_ALREADY_EXISTS') {
                                    showResetPopup(response.message + '\nWould you like to reset your password?');
                                } else if (response.error.message === 'Password is in the list of compromised passwords. ') {
                                    alert(response.error.message);
                                }
                                self.isSubmitting = false;
                                submitButton.textContent = 'Create Account';
                                submitButton.disabled = false;
                                submitButton.hidden = false;
                                submitButton.style.backgroundColor = ' #E31B23';
                            } else {
                                if (response.message === 'Company Name and Contact email already exists') {
                                    if (response.hadAccess) {
                                        showResetPopup('An account with this email already exists.\nWould you like to reset your password?');
                                    } else {
                                        showPopup('Your account has been granted access! Please log in with your new password.');
                                    }
                                } else {
                                    showPopup('Your account has been successfully created! Please log in with your new password.');
                                }
                            }
                        },
                        error: function (e) {
                            alert('An error occurred while submitting the form. Please try again.');
                            self.isSubmitting = false;
                            submitButton.textContent = 'Create Account';
                            submitButton.disabled = false;
                            submitButton.hidden = false;
                            submitButton.style.backgroundColor = ' #E31B23';
                        },
                    });
                },

                getContext: _.wrap(LoginRegisterRegisterView.prototype.getContext, function wrapper(fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));

                    context.isCompanyFieldRequire = true;
                    context.showCompanyField = true;

                    var urlSegmentation = SANDBOX ? URL_SEGMENTATION_SB : URL_SEGMENTATION_PROD;
                    var data = $.ajax({
                        url: urlSegmentation,
                        type: 'GET',
                        contentType: 'application/json',
                        success: function (response) {
                            var segmentationList = response.segmentationList;
                            this.segmentationList = segmentationList;
                            var optionsHtml = '<option value="">-- Select industry --</option>';
                            segmentationList.forEach(function (item) {
                                optionsHtml += `<option value="${item.value}">${item.name}</option>`;
                            });
                            $('#register-industry').html(optionsHtml);

                            var currencyOptionsHtml = '<option value="">-- Select Currency --</option>';
                            CURRENCIES.forEach(function (item) {
                                currencyOptionsHtml += `<option value="${item.id}">${item.name}</option>`;
                            });
                            $('#register-currency').html(currencyOptionsHtml);
                        },
                        error: function (error) {
                            return [];
                        },
                    });

                    var countries = Configuration.get('siteSettings.countries') || {};
                    var countriesArray = _.map(countries, function (country, code) {
                        return {
                            code: code,
                            name: country.name,
                        };
                    });

                    const topCountries = [
                        { name: 'Canada', code: 'CA', isziprequired: 'T' },
                        { name: 'Mexico', code: 'MX', isziprequired: 'T' },
                        { name: 'United States', code: 'US', isziprequired: 'T' },
                        { name: '------------------------', code: 'XX', isziprequired: 'F' },
                    ];

                    countriesArray = [...topCountries, ...countriesArray];
                    context.countries = countriesArray;

                    return context;
                }),

                updateStatesDropdown: function (e) {
                    var selectedCountryId = this.$('#register-country').val();

                    var countryData = _.findWhere(COUNTRIES_WITH_STATES, { id: selectedCountryId });

                    var stateDropdown = this.$('#register-state');
                    stateDropdown.empty();

                    if (countryData && countryData.states.length > 0) {
                        stateDropdown.append('<option value="">' + Utils.translate('-- Select State --') + '</option>');

                        _.each(countryData.states, function (state) {
                            stateDropdown.append('<option value="' + state.code + '">' + state.name + '</option>');
                        });
                    } else {
                        stateDropdown.append('<option value="999">' + Utils.translate('----') + '</option>');
                    }
                },
                validateFormData: function (data) {
                    if (!data.companyName) return { message: 'Company Name is required.', field: '#register-company' };
                    if (!data.custentity_cust_segmentation_pri) return { message: 'Industry Segment field is required.', field: '#register-industry' };
                    if (!data.currency) return { message: 'Preferred Currency is required.', field: '#register-currency' };
                    if (!data.address1) return { message: 'Address is required.', field: '#register-address1' };
                    if (!data.country) return { message: 'Country is required.', field: '#register-country' };
                    if (!data.zip) return { message: 'ZIP Code is required.', field: '#register-zip' };
                    if (!data.firstName) return { message: 'First Name is required.', field: '#register-firstname' };
                    if (!data.lastName) return { message: 'Last Name is required.', field: '#register-lastname' };
                    if (!data.email) return { message: 'Email is required.', field: '#register-email' };
                    if (!data.phone) return { message: 'Phone number is required.', field: '#register-phone' };
                    if (!data.password || !data.password2) return { message: 'Both password fields are required.', field: '#register-password' };
                    if (!data.password2) return { message: 'Both password fields are required.', field: '#register-password' };

                    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(data.email)) return { message: 'Invalid email format.', field: '#register-email' };

                    if (data.password.length < 8) return { message: 'Password must be at least 8 characters long.', field: '#register-password' };
                    if (data.password !== data.password2) return { message: 'Passwords do not match.', field: '#register-password2' };

                    return null;
                },
            });
        },
    };
});
